import ReactPDF, { View } from "@react-pdf/renderer";
import { FC } from "react";
import { styles } from "./styles";

export const TableCell: FC<ReactPDF.ViewProps> = (props) => {
    const { children, ...rest } = props;
    return <View
        {...rest}
        style={{
            ...styles.tableCell,
            ...(rest.style ?? {})
        }}>
        {children}
    </View>
}